import {
  IconAngleRight,
  IconCalculator,
  IconEnvelopeAlt,
  IconReceipt,
} from '@maia/icons';
import { Button, InfoCard, PageHeader, StaticNotification } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { insurance } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De opzegging is ingepland"
        description="Dit kan de klant verwachten"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Bevestigingsmail"
              description="Binnen enkele minuten ontvangt de klant een bevestigings email."
            />
          </li>
          <li>
            <InfoCard
              icon={IconCalculator}
              title="Teruggave"
              description="Eventuele teruggave zal worden berekend en aan de klant gecommuniceerd worden"
            />
          </li>
          <li>
            <InfoCard
              icon={IconReceipt}
              title="Facturen downloaden"
              description="De klant kan nog [periode] inloggen en facturen downloaden"
            />
          </li>
        </ul>

        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Belangrijk!</span> Als er tussen nu en
          de ingangsdatum van de nieuwe verzekering een claim binnenkomt bij
          jouw klant, zorg ervoor dat deze direct wordt gemeld bij de huidige
          verzekeraar.
        </StaticNotification>
        <div className="col-span-full flex justify-end">
          <Link to="/insurances/$guid" params={{ guid: insurance }}>
            <Button intent="primary" iconRight={IconAngleRight}>
              Naar verzekering
            </Button>
          </Link>
        </div>
      </div>
      <div className="area-page-sidebar invisible" />
    </div>
  );
}
